<template>
  <div class="oracle-manage">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
      <div class="fill"></div>
      <instruction-btn
        :id="instruction.oracle.id"
        :instruction-info="instruction.oracle.instructionInfo"
      ></instruction-btn>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="oracleList"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="showEdit"
        :paging="oraclePaging"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="status" slot-scope="{ param }">
          <span class="oracle-status" :class="param.row.IsHealthy ? 'is-normal' : 'is-cancel'">{{
            formatIsHealthy(param.row.IsHealthy) || $constants.EMPTY
          }}</span>
        </template>
      </normal-table>
    </common-bg-plate>
    <create-oracle
      ref="createOracle"
      @update:list="getList()"
      @showDownload="startDownload"
    ></create-oracle>
    <subscribe-dialog ref="subscribeDialog" @update:list="getList()"></subscribe-dialog>
    <contract-dialog ref="contractDialog" @update:list="getList()"></contract-dialog>
    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="下载预言机安装包"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
      :store-file-name="genStoreFileName"
      :sure-text="downloadSureText"
      :cancel-text="downloadCancelText"
      :meta-data="downloadMetaData"
    ></download-dialog>
  </div>
</template>

<script>
import instruction from '@/instruction/index'
import { mapState, mapActions } from 'vuex'
import createOracle from './createOracle.vue'
import subscribeDialog from './subscribeDialog.vue'
import contractDialog from './contractDialog.vue'
import auth from '@/auth/index'
export default {
  name: 'OracleManagement',
  components: {
    createOracle,
    subscribeDialog,
    contractDialog
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新建预言机',
          click: () => {
            return this.createOracleOpen()
          },
          icon: 'icon-add',
          auth: auth.oracle.create
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'OracleID',
          label: '名称',
          minWidth: 149
        },
        {
          prop: 'Chains',
          label: '关联区块链',
          formatter: row => {
            return this.formatChains(row.Chains)
          },
          minWidth: 135
        },
        {
          prop: 'Locality',
          label: '所属组织',
          formatter: row => {
            return this.formatOrg(row.Chains)
          },
          minWidth: 130
        },
        {
          prop: 'Addr',
          label: '所属节点',
          formatter: row => {
            return this.formatNode(row.Chains)
          },
          minWidth: 142
        },
        {
          prop: 'Username',
          label: '用户名称',
          formatter: row => {
            return this.formatUser(row.Chains)
          },
          minWidth: 137
        },
        {
          prop: 'Subscribed',
          label: '订阅状态',
          formatter: row => {
            return this.formatSubScribe(row.Subscribed)
          },
          minWidth: 119
        },
        {
          prop: 'IsHealthy',
          label: '运行状态',
          slotName: 'status',
          minWidth: 107
        },
        {
          prop: 'CreatedTime',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.createAt)
          },
          minWidth: 178
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '订阅',
          click: (row, col, cellValue) => {
            return this.handleSubscribe(row)
          },
          showText: false,
          icon: 'icon-subscribe',
          formatter: (row, col, cellValue) => {
            return !row.Subscribed
          }
        },
        {
          text: '安装默认合约',
          click: (row, col, cellValue) => {
            return this.installDefaultContract(row)
          },
          icon: 'icon-load-contract',
          showText: false
        },
        {
          text: '删除',
          click: (row, col, cellValue) => {
            return this.handleDeleteOracle(row)
          },
          icon: 'icon-cancel',
          showText: false
        },
        {
          text: '下载',
          click: (row, col, cellValue) => {
            this.startDownload(row)
          },
          icon: 'icon-download',
          showText: false
        }
      ],
      operateCol: {
        minWidth: 118
      },
      // 是否显示操作标头
      showEdit: true,
      //下载对话框
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: '',
      downloadSureText: '确 定',
      downloadCancelText: '取 消',
      downloadMetaData: {},
      instruction
    }
  },
  computed: {
    ...mapState({
      oracleList: state => state.oracleManagement.oracle_list,
      oraclePaging: state => state.oracleManagement.oracle_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getList()
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getOracleLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        OracleID: ''
      }
      this.getOracleLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    formatChains(chainsArray) {
      var str = ''
      chainsArray.map((item, index) => {
        str += item.ChainID
        if (index !== chainsArray.length - 1) {
          str += ','
        }
      })
      return str
    },
    formatOrg(chainsArray) {
      var str = ''
      chainsArray.map((item, index) => {
        str += item.OrgName
        if (index !== chainsArray.length - 1) {
          str += ','
        }
      })
      return str
    },
    formatNode(chainsArray) {
      var str = ''
      chainsArray.map((item, index) => {
        str += item.NodeName
        if (index !== chainsArray.length - 1) {
          str += ','
        }
      })
      return str
    },
    formatUser(chainsArray) {
      var str = ''
      chainsArray.map((item, index) => {
        str += item.UserName
        if (index !== chainsArray.length - 1) {
          str += ','
        }
      })
      return str
    },
    formatSubScribe(state) {
      return state ? '已订阅' : '未订阅'
    },
    formatIsHealthy(state) {
      return state ? '正常' : '异常'
    },
    createOracleOpen() {
      this.$refs.createOracle.handleOpen()
    },
    //订阅
    handleSubscribe(row) {
      this.$refs.subscribeDialog.handleOpen(row.OracleID)
    },
    //安装默认合约
    installDefaultContract(row) {
      this.$refs.contractDialog.handleOpen(row)
    },
    //删除
    handleDeleteOracle(row) {
      this.$confirm('确认删除？', '提示')
        .then(_ => {
          this.$apis.oracleManagement.deleteOracle({ oracleID: row.OracleID }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList()
          })
        })
        .catch(_ => {})
    },
    startDownload(data, suggest = false) {
      this.downloadUrl = `/cbaas-service/v1/oracleManagement/downloadOracle?oracleID=${data.OracleID}`
      this.downloadFileName = `预言机${data.OracleID}安装包.zip`
      this.downloadMetaData = data
      this.downloadSureText = suggest ? '下载安装包' : '确 定'
      this.downloadCancelText = suggest ? '稍后下载' : '取 消'
      this.showDownloadDialog = true
    },
    genStoreFileName(xhr, data) {
      // 解析Content-Disposition头部
      let dispositionHeader = xhr.getResponseHeader('Content-Disposition')
      let filename = null
      let match = dispositionHeader.match(/filename=([^;]+)/)
      if (match && match[1]) {
        let base64Filename = match[1]
        // 处理URL安全的base64编码
        base64Filename = base64Filename.replace(/-/g, '+').replace(/_/g, '/')
        // 添加适当数量的填充字符
        while (base64Filename.length % 4 !== 0) {
          base64Filename += '='
        }
        // 解码base64编码的字符串
        filename = decodeURIComponent(escape(atob(base64Filename)))
      }
      return filename || `预言机${data.OracleID}安装包` // 使用解析后的文件名，如果不存在则使用默认文件名
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'oracle-manage',
  (
    --oracle-manage-list-operate-color: #45c2ff,
    --oracle-manage-list-status-normal-color: #55da62,
    --oracle-manage-list-status-cancel-color: #e95757,
    --oracle-manage-list-status-cancel-background-color: rgba(233, 87, 87, 0.34)
  ),
  (
    --oracle-manage-list-operate-color: #45c2ff,
    --oracle-manage-list-status-normal-color: #55da62,
    --oracle-manage-list-status-cancel-color: #e95757,
    --oracle-manage-list-status-cancel-background-color: rgba(233, 87, 87, 0.34)
  )
);
.oracle-manage {
  --oracle-manage-list-min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
  .normal-table-wrap {
    height: 100%;
    min-height: var(--oracle-manage-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--oracle-manage-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--oracle-manage-list-min-height);

        .oracle-status {
          padding: var(--base-size-2) var(--base-size-8);
          display: inline-block;
          &.is-normal {
            color: var(--oracle-manage-list-status-normal-color);
          }

          &.is-cancel {
            color: var(--oracle-manage-list-status-cancel-color);
            background-color: var(--oracle-manage-list-status-cancel-background-color);
          }
        }

        .operate-item {
          color: var(--oracle-manage-list-operate-color);
        }
      }
    }
  }
}
</style>
